import { VideoProviderType } from '@core/models/offer/enums';

export enum StatisticsType {
    statistics = 'statistics',
    tables = 'tables',
    h2h = 'h2h',
    cupRoster = 'cupRoster',
    lineups = 'lineups',
    matchDetails = 'matchDetails',
}

export enum StreamState {
    NotAvailable = 'NotAvailable',
    NotStarted = 'NotStarted',
    Loading = 'Loading',
    Playing = 'Playing',
    Closed = 'Closed',
}

export enum StreamSection {
    Video = VideoProviderType.BETRADAR,
    Youtube = VideoProviderType.YOUTUBE,
    Twitch = VideoProviderType.TWITCH,
    Perform = VideoProviderType.PERFORM,
    BetGenius = VideoProviderType.BET_GENIUS,
    Img = VideoProviderType.IMG,
    Infrontsports = VideoProviderType.INFRONTSPORTS,
    Beter = VideoProviderType.BETER,
    Visualization = 100000,
}

export const VideoProviderToStreamSection: Record<VideoProviderType, StreamSection> = {
    [VideoProviderType.IMG]: StreamSection.Video,
    [VideoProviderType.BETRADAR]: StreamSection.Video,
    [VideoProviderType.YOUTUBE]: StreamSection.Youtube,
    [VideoProviderType.TWITCH]: StreamSection.Twitch,
    [VideoProviderType.PERFORM]: StreamSection.Perform,
    [VideoProviderType.BET_GENIUS]: StreamSection.BetGenius,
    [VideoProviderType.IMG_VISUALIZATION_WIDGET]: StreamSection.Visualization,
    [VideoProviderType.INFRONTSPORTS]: StreamSection.Video,
    [VideoProviderType.BETER]: StreamSection.Beter,
} as const;
